/**
 * Client-side guards that make the installed / mobile web experience feel less like a browser page.
 * Safe to call once at app bootstrap.
 *
 * Intentionally light: aggressive touch preventDefault causes scroll/glitch issues on mobile.
 */
export function bootstrapPwaClientGuards(doc: Document = document): () => void {
    const onGestureStart = (event: Event) => {
        // iOS Safari pinch-zoom gesture
        event.preventDefault();
    };

    const onTouchStart = (event: TouchEvent) => {
        // Only block true multi-finger pinch, not normal scrolling / swipes.
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    };

    doc.addEventListener('gesturestart', onGestureStart as EventListener, { passive: false } as AddEventListenerOptions);
    doc.addEventListener('touchstart', onTouchStart, { passive: false });

    doc.documentElement.classList.add('pwa-client-ready');

    return () => {
        doc.removeEventListener('gesturestart', onGestureStart as EventListener);
        doc.removeEventListener('touchstart', onTouchStart);
        doc.documentElement.classList.remove('pwa-client-ready');
    };
}
